const CUSTOM_ANALYTICS_EVENT = 'hdt:custom-analytics';

function publishCollectionExpansion(interactionSource) {
  document.dispatchEvent(new CustomEvent(CUSTOM_ANALYTICS_EVENT, {
    detail: {
      type: 'collection_description_expand',
      params: { interaction_source: interactionSource }
    }
  }));
}

class CollectionDescriptionDisclosure extends HTMLElement {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    if (this.isConnectedToDisclosure) return;

    this.content = this.querySelector('[data-collection-description-content]');
    this.toggleButton = this.querySelector('[data-collection-description-toggle]');
    this.label = this.querySelector('[data-collection-description-label]');

    if (!this.hasAttribute('data-collapsible') || !this.content || !this.toggleButton || !this.label) return;

    this.isConnectedToDisclosure = true;
    this.classList.add('is-enhanced');
    this.toggleButton.hidden = false;
    this.setExpanded(false);
    this.toggleButton.addEventListener('click', this.handleToggle);
  }

  handleToggle() {
    const willExpand = !this.classList.contains('is-expanded');
    this.setExpanded(willExpand);
    if (willExpand) publishCollectionExpansion('toggle');
    if (!willExpand) this.scrollToDescription();
  }

  setExpanded(expanded) {
    if (!this.toggleButton || !this.label) return;

    this.classList.toggle('is-expanded', expanded);
    this.toggleButton.setAttribute('aria-expanded', String(expanded));
    this.label.textContent = expanded
      ? this.toggleButton.dataset.readLess
      : this.toggleButton.dataset.readMore;
  }

  expandAndScroll() {
    this.setExpanded(true);
    this.scrollToDescription();
  }

  scrollToDescription() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }
}

function handleCollectionDescriptionTrigger(event) {
  const trigger = event.target.closest?.('[data-collection-description-trigger]');
  if (!trigger) return;

  const href = trigger.getAttribute('href');
  if (!href || !href.startsWith('#')) return;

  const target = document.getElementById(href.slice(1));
  if (!target || typeof target.expandAndScroll !== 'function') return;

  event.preventDefault();
  if (!target.classList.contains('is-expanded')) publishCollectionExpansion('heading_link');
  target.expandAndScroll();
}

if (!customElements.get('collection-description-disclosure')) {
  customElements.define('collection-description-disclosure', CollectionDescriptionDisclosure);
  document.addEventListener('click', handleCollectionDescriptionTrigger);
}
